import { CONDITIONS } from '@src/constants/safehaven/health-record/conditions'
import { SYMPTOMS } from '@src/constants/safehaven/health-record/symptoms'
import { SURGERIES } from '@src/constants/safehaven/health-record/surgeries'
import { PROCEDURES } from '@src/constants/safehaven/health-record/procedures'
import { MEDICATIONS } from '@src/constants/safehaven/health-record/medications'
import { SUPPLEMENTS } from '@src/constants/safehaven/health-record/supplements'
import { IMMUNIZATIONS } from '@src/constants/safehaven/health-record/immunizations'
import { ALLERGIES } from '@src/constants/safehaven/health-record/allergies'
import { FAMILY_HISTORY } from '@src/constants/safehaven/health-record/family_history'
import { SOCIAL_HISTORY } from '@src/constants/safehaven/health-record/social_history'
import { MEDICAL_VISITS } from '@src/constants/safehaven/health-record/medical_visits'
import { LABS } from '@src/constants/safehaven/health-record/labs'
import { DIAGNOSTICS } from '@src/constants/safehaven/health-record/diagnostics'
import { TRAVEL_HISTORY } from '@src/constants/safehaven/health-record/travel_history'
export const hrGroups = {
  MEDICAL_HISTORY: 1,
  MEDICATIONS: 2,
  DIAGNOSTICS: 3,
  ALLERGIES: 4,
  VISITS: 5,
}

export const healthRecord = {
  CONDITIONS,
  SYMPTOMS,
  MEDICATIONS,
  ALLERGIES,
  IMMUNIZATIONS,
  LABS,
  DIAGNOSTICS,
  MEDICAL_VISITS,
  SURGERIES,
  PROCEDURES,
  SOCIAL_HISTORY,
  FAMILY_HISTORY,
  SUPPLEMENTS,
  TRAVEL_HISTORY,
}

export const healthRecordAddModel = {
  CONDITIONS,
  SYMPTOMS,
  MEDICATIONS,
  ALLERGIES,
  IMMUNIZATIONS,
  LABS,
  DIAGNOSTICS,
  MEDICAL_VISITS,
  SURGERIES,
  PROCEDURES,
  SOCIAL_HISTORY,
  FAMILY_HISTORY,
  SUPPLEMENTS,
  TRAVEL_HISTORY,
}

export const healthRecordModels = {
  condition: 'CONDITIONS',
  symptom: 'SYMPTOMS',
  surgery: 'SURGERIES',
  procedure: 'PROCEDURES',
  medication: 'MEDICATIONS',
  supplement: 'SUPPLEMENTS',
  immunization: 'IMMUNIZATIONS',
  allergy: 'ALLERGIES',
  familyhistory: 'FAMILY_HISTORY',
  socialhistory: 'SOCIAL_HISTORY',
  medicalvisit: 'MEDICAL_VISITS',
  lab: 'LABS',
  diagnostic: 'DIAGNOSTICS',
  imaging: 'IMAGINGS',
  travelhistory: 'TRAVEL_HISTORY',
}
